import { render, staticRenderFns } from "./AuthorizedActions.vue?vue&type=template&id=91073e56"
import script from "./AuthorizedActions.vue?vue&type=script&lang=js"
export * from "./AuthorizedActions.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedActions.vue?vue&type=style&index=0&id=91073e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports